"use client";
import { useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";

export default function ScrollToTop() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    // Completely disable ScrollToTop on quote page - it handles its own scrolling
    const isQuotePage = pathname.includes('/wedding-flowers/quote');

    if (isQuotePage) {
      return;
    }

    // Scroll to top for all other navigation
    window.scrollTo({ top: 0, left: 0 });
  }, [pathname, searchParams?.toString()]);

  return null;
}
